<article
  class="eventq-alert"
  [class.eventq-alert--default]="usesDefaultSurface()"
  [class.eventq-alert--loading]="loading()"
  [style.background-color]="resolvedBackgroundColor()"
  [style.border-color]="resolvedBorderColor()"
  [attr.aria-busy]="loading() ? true : null"
  [attr.aria-label]="loading() ? 'Loading alert' : heading()"
  role="status"
>
  @if (loading()) {
    <div class="eventq-alert__skeleton" aria-hidden="true">
      <span class="eventq-alert__skeleton-icon"></span>
      <div class="eventq-alert__skeleton-copy">
        <span class="eventq-alert__skeleton-line eventq-alert__skeleton-line--title"></span>
        <span class="eventq-alert__skeleton-line eventq-alert__skeleton-line--body"></span>
        <span class="eventq-alert__skeleton-line eventq-alert__skeleton-line--body-short"></span>
      </div>
    </div>
  } @else {
    <div class="eventq-alert__main">
      <span class="eventq-alert__icon" aria-hidden="true">
        <img [src]="iconSrc() | prefixUrl" alt="" width="24" height="24" />
      </span>

      <div class="eventq-alert__content">
        <div class="eventq-alert__copy">
          <p class="eventq-alert__heading">{{ heading() }}</p>
          <p class="eventq-alert__body">{{ body() }}</p>
        </div>

        @if (showMetadata()) {
          <div class="eventq-alert__metadata">
            @if (showDate()) {
              <div class="eventq-alert__date">
                @if (dateIconSrc()) {
                  <img [src]="dateIconSrc() | prefixUrl" alt="" width="16" height="16" />
                }
                <div class="eventq-alert__date-text">
                  @if (dateRangeStart()) {
                    <span>{{ dateRangeStart() }}@if (dateRangeEnd()) { -}</span>
                  }
                  @if (dateRangeEnd()) {
                    <span>{{ dateRangeEnd() }}</span>
                  }
                </div>
              </div>
            }

            @if (showUser()) {
              <div class="eventq-alert__user">
                @if (userIconSrc()) {
                  <img [src]="userIconSrc() | prefixUrl" alt="" width="16" height="16" />
                }
                <span>{{ username() }}</span>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</article>
